import React, { useState } from "react";
import { Card, Tabs } from 'antd';
import InsuranceDefaultWages from '../components/setting/InsuranceDefaultWages';
import CompanyDefaultWages from '../components/setting/CompanyDefaultWages';


const { TabPane } = Tabs;
const MarketerWageSettings = () => {

    const [tabId, setTabId] = useState("1");


    function tabIdSetter(key) {
        setTabId(key);
    }


    return (
        <Card className="marketerWageSettings-tab ">
            <Tabs
                defaultActiveKey="1"
                activeKey={tabId}
                onChange={tabIdSetter}
            >
                <TabPane tab="تنظیم پیش فرض کارمزد بازاریاب در هر رشته" key="1" >
                    <InsuranceDefaultWages insuranceWagesId={tabId} />
                </TabPane>
                <TabPane tab="تنظیم پیش فرض کارمزد بازاریاب برای هر شرکت" key="2" >
                    <CompanyDefaultWages companyWagesId={tabId} />
                </TabPane>
            </Tabs>
        </Card>
    )
}
export default MarketerWageSettings;